import React from "react";
import AboutUsImage from "../../../assets/aboutus.webp";
import TeamMember from "../TeamMember";
import radharaman from "../../../assets/radharaman.jpg";
import zunaidahmad from "../../../assets/zunaid_ahmad.jpg";
import rohandogra from "../../../assets/rohan_dogra.jpg";
import hardika from "../../../assets/hardika_bajaj.jpg";
import SC from "./style";

const fadeInLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 0.5 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const teamMembers = [
  {
    name: "Radharaman Lath",
    role: "CEO & MD",
    image: radharaman,
    twitterUrl: "https://www.linkedin.com/company/innologic.in/",
    linkedinUrl: "https://www.linkedin.com/company/innologic.in/",
  },
  {
    name: "Zunaid Ahmad",
    role: "Product Engineer",
    image: zunaidahmad,
    twitterUrl: "https://www.linkedin.com/company/innologic.in/",
    linkedinUrl: "https://www.linkedin.com/company/innologic.in/",
  },
  {
    name: "Rohan Dogra",
    role: "Product Engineer",
    image: rohandogra,
    twitterUrl: "https://www.linkedin.com/company/innologic.in/",
    linkedinUrl: "https://www.linkedin.com/company/innologic.in/",
  },
  {
    name: "Hardika",
    role: "Business Manager",
    image: hardika,
    twitterUrl: "https://www.linkedin.com/company/innologic.in/",
    linkedinUrl: "https://www.linkedin.com/company/innologic.in/",
  },
];

function AboutUs() {
  return (
    <div
      style={{
        backgroundColor: "#205F9C",
        margin: "10px",
        borderRadius: "20px",
      }}
    >
      <SC.Container>
        <SC.ContentSection
          whileInView="visible"
          initial="hidden"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInLeft}
        >
          <SC.ProductLabel>About Us</SC.ProductLabel>
          <SC.Title>Empowering Teams, Driving Success.</SC.Title>
          <SC.Description>
            We are a team of passionate innovators dedicated to simplifying
            project management. With AI-driven tools and intuitive workflows, we
            help businesses achieve more with less effort.
          </SC.Description>
          <SC.Description>
            We are a team of passionate innovators dedicated to simplifying
            project management. With AI-driven tools and intuitive workflows, we
            help businesses achieve more with less effort.
          </SC.Description>

          <SC.GetStartedButton>
            Learn More <span style={{ marginLeft: "5px" }}>→</span>
          </SC.GetStartedButton>
        </SC.ContentSection>
        <SC.ImageContainer
          whileInView="visible"
          initial="hidden"
          viewport={{ once: true, amount: 0.4 }}
          variants={fadeIn}
        >
          <SC.Image src={AboutUsImage} alt="Team collaborating on a project" />
        </SC.ImageContainer>
      </SC.Container>
      <SC.HrTag />
      <SC.TeamContianer
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1 * 0.2 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <SC.Grid>
          {teamMembers.map((member) => (
            <TeamMember
              key={member.name}
              name={member.name}
              role={member.role}
              image={member.image}
              twitterUrl={member.twitterUrl}
              linkedinUrl={member.linkedinUrl}
            />
          ))}
        </SC.Grid>
      </SC.TeamContianer>
    </div>
  );
}

export default AboutUs;
